import { Component, OnInit } from '@angular/core';
import { ModalService } from '@shared/errors/modal/modal.service';

@Component({
  selector: 'shell-withdrawal-agency',
  templateUrl: './withdrawal-agency.component.html',
  styleUrls: ['./withdrawal-agency.component.scss'],
})
export class WithdrawalAgencyComponent implements OnInit {
  constructor(public modalService: ModalService) {}

  ngOnInit() {}

  closeModal() {
    this.modalService.close();
    window.location.href = window.location.origin + '/#/prestamo-personal/gral/datos';
  }
}
